import { toEnginePath } from '@/pages/User/pages/MergeRequests/mapMergeRequest'
import {
	BranchRebaseConflictDto,
	BranchRebaseConflictResolutions,
	DiffChangeDto,
} from '@/rtkApi/mddApiSliceGeneratedV2'

export type RebaseChoice = 'source' | 'target' | 'custom'

export type RebaseResultShape = {
	blockingMergeRequests?: unknown[]
	conflicts?: { conflicts?: unknown[] }[]
	message?: string
}

export const canRebaseBranch = (branch: {
	protectedBranch?: boolean
	sourceBranchId: string | null
	status: string
}) =>
	Boolean(branch.sourceBranchId) &&
	branch.status === 'ACTIVE' &&
	!branch.protectedBranch

export const rebaseResultKind = (
	result: RebaseResultShape,
): 'blocked' | 'conflicts' | 'message' | 'done' => {
	if ((result.blockingMergeRequests?.length ?? 0) > 0) return 'blocked'
	const hasConflicts = (result.conflicts ?? []).some(
		(group) => (group.conflicts?.length ?? 0) > 0,
	)
	if (hasConflicts) return 'conflicts'
	if (result.message) return 'message'
	return 'done'
}

export const rebaseResolutionValue = (
	change: Pick<DiffChangeDto, 'newValue' | 'oldValue'>,
	choice: RebaseChoice,
	customValue?: unknown,
): unknown => {
	if (choice === 'custom') return customValue === undefined ? null : customValue
	const value = choice === 'source' ? change.newValue : change.oldValue
	return value === undefined ? null : value
}

export const rebaseFieldForPath = (
	group: BranchRebaseConflictDto,
	enginePath: string,
): DiffChangeDto | undefined =>
	(group.conflicts ?? []).find(
		(conflict) =>
			conflict.fieldPath != null && toEnginePath(conflict.fieldPath) === enginePath,
	)

export const rebaseSelectionsComplete = (
	conflicts: BranchRebaseConflictDto[],
	selected: BranchRebaseConflictResolutions,
): boolean =>
	conflicts.every((group) => {
		if (group.structureId == null) return false
		const chosen = selected[String(group.structureId)] ?? {}
		return (group.conflicts ?? [])
			.filter((conflict) => conflict.fieldPath)
			.every((conflict) =>
				Object.prototype.hasOwnProperty.call(chosen, conflict.fieldPath as string),
			)
	})
